// extracted by mini-css-extract-plugin
export var flexItem = "phaseTwo-module--flexItem--Lc+Xr";
export var textContainer = "phaseTwo-module--textContainer--QWO8B";